import { createAction, props } from '@ngrx/store';
import { ICountryData, ICountryModel } from '@partners/api';

export class CountryActions {
  static reset = createAction('[Country] Reset State');
  static load = createAction('[Country] Load');
  static loadSuccess = createAction('[Country] Load Success', props<{ model: ICountryModel; data: ICountryData }>());
  static loadFailure = createAction('[Country] Load Failure', props<{ error: any }>());
  static submit = createAction('[Country] Submit', props<{ model: ICountryModel }>());
  static submitSuccess = createAction('[Country] Submit Success', props<{ data: ICountryData }>());
  static submitFailure = createAction('[Country] Submit Failure', props<{ error: any }>());
}
